import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { toast } from "react-toastify";

export interface IMergeBatchesPayload {
    sourceBatchId: string;
    targetBatchId: string;
}

export const useMergeBatches = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: IMergeBatchesPayload) => {
            const res = await apiClient.post(ENDPOINTS.BATCHES.MERGE, payload);
            return res.data;
        },
        onSuccess: (data, variables) => {
            toast.success(data?.message || "Batches merged successfully!");
            queryClient.invalidateQueries({ queryKey: ["get_all_batches"] });
            queryClient.invalidateQueries({ queryKey: ["get_batch_by_id", variables.sourceBatchId] });
            queryClient.invalidateQueries({ queryKey: ["get_batch_by_id", variables.targetBatchId] });
        },
        onError: (err: any) => {
            toast.error(err?.response?.data?.message || err?.message || "Failed to merge batches");
        },
    });
};
